import { render, staticRenderFns } from "./OrdonnanceManagement.vue?vue&type=template&id=1bb362b4&"
import script from "./OrdonnanceManagement.vue?vue&type=script&lang=js&"
export * from "./OrdonnanceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports